import React from 'react';

import { compose, identity, pick } from 'ramda';

import { useIsAdmin } from 'js/hooks/user';
import { useUserSelector } from 'js/store/hooks';
import { useTranslations } from 'js/hooks/i18n';
import { withDynamicReducer } from 'js/components/system/Portlet/store/context';
import { withPortletContext, withPortletFetch } from 'js/components/system/Portlet/hocs/withPortlet';

export * from 'js/components/system/Portlet/hocs/withPortlet';

/** core, added isAdmin (line 20) */
export const withForLoggedIn = Component => (props) => {
    const { isLoggedIn, role } = useUserSelector(pick(['isLoggedIn', 'role']));
    const t = useTranslations('playtech.mobile.system.portlet.portletIsUnavailable.');

    const isAdmin = useIsAdmin();

    if (!isLoggedIn && !isAdmin) {
        return t(role);
    }

    return <Component {...props} />;
};

/** core  */
export const withPortlet = ({
    forLoggedIn,

    parseCms,

    reducer,
    initialState,
    name = 'Portlet',

    fetch,
    useParams,
    onResponse,
    onError,
    Loader,
    Error
} = {}) => {
    const enhancers = [];

    if (forLoggedIn) {
        enhancers.push(withForLoggedIn);
    }

    // r/o context with portlet CMS config
    enhancers.push(withPortletContext({ parseCms }));

    if (reducer) {
        // r/w context with portlet reducer
        enhancers.push(withDynamicReducer({ reducer, initialState, reducerName: name }));
    }

    if (fetch) {
        enhancers.push(withPortletFetch({ fetch, useParams, onResponse, onError, Loader, Error }));
    }

    switch (enhancers.length) {
        case 0:
            return identity;
        case 1:
            return enhancers[0];
        default:
            return compose(...enhancers);
    }
};
